<p>search-gif works!</p>
